import { OnboardingWebPageResponse } from 'commons/types/DTO/commons'

import { OnboardingFormActions } from '../../../enums'
import { SetInitApplicationAction } from '../../../types/actions'

export const setInitApplication = (application: OnboardingWebPageResponse): SetInitApplicationAction => ({
  type: OnboardingFormActions.SET_INIT_APPLICATION,
  payload: application
})
